import { Component, OnInit, HostListener } from '@angular/core';
import { AuthenticationService } from '../_services/authentication.service';

@Component({
  selector: 'app-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrls: ['./profile-details.component.scss']
})
export class ProfileDetailsComponent implements OnInit {
  PersonalMenus = [
    { 
      "personal_path": "details","personal_title":"Profile"
  },
    {
      "personal_path": "change-password", "personal_title": "Change Password"
    },
]
  innerWidth: number;

  constructor(private auth:AuthenticationService) { }

  ngOnInit(): void {
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }
  openNav() {
    document.getElementById("mySidenav").style.width = "320px";
  }
  logout() {
    this.auth.logout();
  }
  closeNav() {
    if (this.innerWidth < 800)
      document.getElementById("mySidenav").style.width = "0";
  }
}
